// frontend/src/components/ErrorDisplay.js
import React from 'react';
import {
  Box,
  Alert,
  AlertIcon,
  Button,
  Text,
  HStack,
  VStack
} from '@chakra-ui/react';

const ErrorDisplay = ({ 
  errorInfo, 
  onRetry, 
  onCancel, 
  isRetrying = false 
}) => {
  if (!errorInfo) return null;

  const getAlertStatus = (variant) => {
    switch (variant) {
      case 'warning': return 'warning';
      case 'error': return 'error';
      default: return 'error';
    }
  };

  return (
    <Box maxW="4xl" mx="auto" mt={4}>
      <Alert
        status={getAlertStatus(errorInfo.variant)}
        borderRadius="md"
        flexDirection="column"
        alignItems="flex-start"
        p={4}
      >
        <HStack mb={3} align="flex-start">
          <AlertIcon />
          <VStack align="flex-start" spacing={1} flex="1">
            <Text fontWeight="600" fontSize="md">
              {errorInfo.icon} {errorInfo.title}
            </Text>
            <Text fontSize="sm" color="gray.600">
              {errorInfo.message}
            </Text>
          </VStack>
        </HStack>
        
        {errorInfo.showRetry && (
          <HStack spacing={3} mt={2}>
            <Button
              colorScheme={errorInfo.variant === 'warning' ? 'orange' : 'red'}
              variant="solid"
              onClick={onRetry}
              isLoading={isRetrying}
              loadingText="Retrying..."
              size="sm"
            >
              {errorInfo.buttonText || 'Retry'}
            </Button>
            <Button 
              variant="ghost" 
              onClick={onCancel} 
              size="sm"
              isDisabled={isRetrying}
            >
              Cancel
            </Button>
          </HStack>
        )}
      </Alert>
    </Box>
  );
};

export default ErrorDisplay;